import { store } from '../../store';
import {
  setToken,
  updateCurrentUser,
  logout as logoutAction,
} from '../../store/slices/authSlice';
import { env } from '../../config/env';
import axios from 'axios';
import { getAxiosErrorMessage } from '../../utils/getAxiosErrorMessage';

const apiUrl = env.apiUrl;

async function fetchAndStoreUser(accessToken) {
  const userInfoResponse = await axios.get(`${apiUrl}/auth/user-info`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });

  const userData = userInfoResponse.data;
  store.dispatch(updateCurrentUser(userData));

  return {
    id: userData.sub,
    firstName: userData.given_name,
    lastName: userData.family_name,
    name: `${userData.given_name} ${userData.family_name}`.trim(),
    email: userData.email,
    role: userData.role,
  };
}

export const authService = {
  async login(email, password) {
    const body = new URLSearchParams({
      grant_type: 'password',
      username: email,
      password,
      scope: 'email profile roles offline_access',
    });

    try {
      const tokenResponse = await axios.post(`${apiUrl}/auth/token`, body.toString(), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });

      const tokenData = tokenResponse.data;

      store.dispatch(
        setToken({
          token: tokenData.access_token,
          refreshToken: tokenData.refresh_token || null,
          expiresAt: tokenData.expires_in
            ? Date.now() + tokenData.expires_in * 1000
            : null,
        })
      );

      const user = await fetchAndStoreUser(tokenData.access_token);

      return {
        success: true,
        user,
        token: tokenData.access_token,
      };
    } catch (err) {
      throw new Error(
        getAxiosErrorMessage(err, 'Login failed. Please check your credentials.')
      );
    }
  },

  logout() {
    store.dispatch(logoutAction());
  },

  getCurrentUser() {
    const state = store.getState();
    return state.auth.user || null;
  },

  isAuthenticated() {
    const state = store.getState();
    return state.auth.isAuthenticated;
  },

  getToken() {
    const state = store.getState();
    return state.auth.token || null;
  }
};
